module.exports = __webpack_public_path__ + "static/media/spinner-loader.276efa7e.svg";